module.exports = (s) => {
  return [
    {
      name: '转化ID',
      value: 'id',
    },
    {
      name: '转化名称',
      value: 'name',
    },
    {
      name: '优化目标',
      value: 'optimization_goal',
      format: ({ convert_goal }) => {
        const form_context = s.local_sharing_data.getFormContext();
        const { channel_interface } = form_context.config.init_ops;
        const convert_goal_enum_val = s.$store.getters[`${channel_interface}EnumVal`].api_fusion_convert_goal;
        return convert_goal_enum_val[convert_goal] || '-';
      },
    },
    {
      name: '深度优化目标',
      value: '',
      format: ({ deep_convert_goal }) => {
        const form_context = s.local_sharing_data.getFormContext();
        const { channel_interface } = form_context.config.init_ops;
        const deep_convert_goal_enum_val = s.$store.getters[`${channel_interface}EnumVal`].api_fusion_deep_convert_type;
        return deep_convert_goal_enum_val[deep_convert_goal] || '-';
      },
    },
    {
      name: '操作',
      width: 90,
      align: 'center',
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-button',
          {
            props: {
              disabled: (() => {
                /**
                 * 渠道列表为空
                 * 当前行转化ID与渠道列表存在交集
                 * 渠道列表中所有渠道都已选择(暂时不考虑)
                 */
                const is_empty = s.tableSources.list.length === 0;
                const is_exist = !!(s.tableSources.list.find((channel) => channel.conversion ? JSON.parse(channel.conversion)?.id === row.id : false));
                return is_empty || is_exist;
              })(),
              type: 'text',
            },
            on: {
              click: () => {
                s.onDataDialogConfirm(row);
              },
            },
          },
          '应用转化',
        );
        return ele;
      },
    },
  ];
};
